var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClientRequirements = function SvgClientRequirements(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M0 20v3h17v-3c0-2.8-2.2-5-5-5H5c-2.8 0-5 2.2-5 5m2 0c0-1.7 1.3-3 3-3h7c1.7 0 3 1.3 3 3v1H2zM4 9.5C4 12 6 14 8.5 14S13 12 13 9.5 11 5 8.5 5 4 7 4 9.5m7 0c0 1.4-1.1 2.5-2.5 2.5S6 10.9 6 9.5 7.1 7 8.5 7 11 8.1 11 9.5M21 0h-2v9h2zM21 10h-2v2h2z"
  })));
};
export default SvgClientRequirements;